module.exports = __webpack_public_path__ + "img/flags/WS.bf46e06.png";